import { useAuth } from './AuthContext';
import { AuthScreen } from './AuthScreen';
import { BootstrapAdminForm } from './BootstrapAdminForm';
import { InviteLandingPage } from './InviteLandingPage';
import { LoginForm } from './LoginForm';

function inviteTokenFromLocation(): string | null {
  return new URLSearchParams(window.location.search).get('invite');
}

/**
 * Gates the whole app behind an account — boards included.
 *
 * Boards used to be reachable by link alone, with the role read from the
 * address bar. They are not: a `?b=` link now lands here first, and the board
 * then asks the server whether this account may open it.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { user, needsBootstrap, error, refresh } = useAuth();
  const inviteToken = inviteTokenFromLocation();

  if (error) {
    return (
      <AuthScreen title="Ygrik Board недоступен" subtitle={error}>
        <button type="button" className="primary-btn auth-submit" onClick={() => void refresh()}>
          Повторить
        </button>
      </AuthScreen>
    );
  }

  // Initial status fetch still in flight.
  if (user === undefined) {
    return (
      <AuthScreen title="Ygrik Board">
        <p className="auth-hint">Загрузка…</p>
      </AuthScreen>
    );
  }

  if (needsBootstrap) return <BootstrapAdminForm />;

  // An invite link is handled the same whether or not the visitor is already
  // signed in — see InviteLandingPage for why.
  if (inviteToken) return <InviteLandingPage token={inviteToken} />;

  if (!user) return <LoginForm />;

  return <>{children}</>;
}
